module.exports = __webpack_public_path__ + "media/login-bg-2.2750fda2.mp4";